export default "__VITE_ASSET__D9j6k898__"